import React, { FC, useMemo } from 'react';
import BoothProfileContainer from 'pages/booths/BoothProfileContainer';
import {
  DockLayout, LayoutData, PanelData, TabGroup,
} from 'rc-dock';
import 'rc-dock/dist/rc-dock.css';
import LiveStreamBoothExhibitorPanel from 'components/pictureInPicture/LiveStreamBoothExhibitorPanel';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

export interface BoothExhibitorPanelProps {
  boothId: string
}

const StyledTabContentContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 4px;
  background: #C1D5DA;

  & .dock-style-main {
    border: #CCC 1px solid;
  }
`;

const usePanels = (boothId) => useMemo(() => ({
  exhibitorPanel: {
    tabs: [{
      group: 'main',
      id: 'exhibitor-panel',
      title: 'Exhibitor Panel',
      cached: true,
      content: <StyledTabContentContainer />,
    }],
    size: 150,
    minHeight: 150,
  } as PanelData,

  boothActivities: {
    tabs: [{
      group: 'main',
      id: 'booth-activities',
      title: 'Booth Activities',
      cached: true,
      content: <StyledTabContentContainer />,
    }],
  } as PanelData,

  boothContent: {
    tabs: [{
      group: 'main',
      id: 'booth',
      title: 'Booth',
      cached: true,
      content: (
        <StyledTabContentContainer>
          <BoothProfileContainer boothId={boothId} isPreview />
        </StyledTabContentContainer>
      ),
    }],
  } as PanelData,

  liveStreamControl: {
    size: 75,
    tabs: [{
      group: 'main',
      id: 'livestream',
      title: 'Live Stream',
      cached: true,
      content: (
        <StyledTabContentContainer>
          <LiveStreamBoothExhibitorPanel boothId={boothId} />
        </StyledTabContentContainer>
      ),
    }],
  } as PanelData,

  chat: {
    tabs: [{
      group: 'main',
      id: 'chat',
      title: 'Chat',
      cached: true,
      content: <StyledTabContentContainer />,
    }],
  } as PanelData,

}), [boothId]);

const mainGroup: TabGroup = {
  maximizable: false,
  floatable: true,
};

const groups = { main: mainGroup };

const EMPTY_ARRAY = [];

const BoothExhibitorPanel: FC<BoothExhibitorPanelProps> = ({ boothId }) => {
  const panels = usePanels(boothId);

  const enabledLiveStreamPeriods = useSelector((state: any) => state.eventConfigs)?.liveStream?.boothIdLiveStreamPeriodsMap?.[boothId] ?? EMPTY_ARRAY;
  const defaultLayout = useMemo(() => ({
    dockbox: {
      mode: 'horizontal',
      children: enabledLiveStreamPeriods?.length === 0 ? [panels.boothContent] : [
        panels.liveStreamControl,
        panels.boothContent,
      ],
    },
  } as LayoutData), [enabledLiveStreamPeriods?.length, panels.boothContent, panels.liveStreamControl]);

  return (
    <StyledContainer>
      <DockLayout
        dropMode="edge"
        onLayoutChange={(e) => console.log(e)}
        groups={groups}
        defaultLayout={defaultLayout}
        style={{
          height: 'calc(100%)',
          width: '100%',
        }}
      />
    </StyledContainer>
  );
};

export default React.memo(BoothExhibitorPanel);
